import {
  PLAY_SONG,
  PLAY_ALBUM,
  TOGGLE_PLAY_PAUSE,
  OPEN_PLAYER_MODAL,
  CLOSE_PLAYER,
  SET_SEEKING,
  SET_DURATION,
  SET_PLAYED_SECONDS,
  SET_PLAYED,
  SET_BUFFERING
} from 'context/constants';
import { convertAlbum } from 'utils/itemUtil';
import axios from 'axios';

export const openPlayerModal = () => ({ type: OPEN_PLAYER_MODAL });
export const closePlayer = () => ({ type: CLOSE_PLAYER });
export const playSong = song => ({ type: PLAY_SONG, payload: song });
export const togglePlayPause = () => ({ type: TOGGLE_PLAY_PAUSE });
export const setloading = () => ({ type: 'SET_LOADING' });

export const playAlbum = album => ({
  type: PLAY_ALBUM,
  payload: album
});
export const setInfo = info => ({
  type: 'SET_INFO',
  payload: info
});

export const setMusicCurrency = musicCurrency => ({
  type: 'SET_MUSIC_CURRENCY',
  payload: musicCurrency
});

export const setAlbumPrices = albumPrices => ({
  type: 'SET_ALBUM_PRICES',
  payload: albumPrices
});

export const setDuration = duration => ({
  type: SET_DURATION,
  payload: duration
});

export const setSeeking = seeking => ({
  type: SET_SEEKING,
  payload: seeking
});

export const setPlayedSeconds = seconds => ({
  type: SET_PLAYED_SECONDS,
  payload: seconds
});

export const setPlayed = played => ({
  type: SET_PLAYED,
  payload: played
});

export const setBuffering = isBuffering => ({
  type: SET_BUFFERING,
  payload: isBuffering
});

export const previewMusic = async (id, dispatch) => {
  let url = `${process.env.REACT_APP_API_URL}/digital_content/album/public/${id}`;
  try {
    dispatch(setloading());
    const res = await axios.get(url);
    const { data } = res;
    const response = convertAlbum(data);
    dispatch(closePlayer()); //needs refactor but Somehow improves glitch btwn loading and opening modal
    dispatch(openPlayerModal());
    dispatch(playSong(response.tracks[0]));
    dispatch(playAlbum(response && response.tracks));
    dispatch(setloading());
  } catch (error) {
    dispatch(setloading());
    console.error(error.response);
  }
};
